import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flow } from 'signup-constants/Flow';
import { getIntegrationName } from '../utils/getIntegrationName';
import { isFlow } from '../utils/isFlow';
import { CustomTermsAndConditions, StyledPrivacyBanner } from './CustomTermsAndConditions';
import { usePrivacyBanner } from './usePrivacyBanner';
import { Text } from 'foundations-components/components/Text';
import { useTheme, isTrellisTheme } from 'foundations-theming/utils';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { getLegalLink } from '../legal/getLegalLink';
import { useIsSU0004Variation } from '../hooks/useIsSU0004Variation';
import { jsx as _jsx } from "react/jsx-runtime";
const PrivacyBanner = () => {
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  const {
    isEmbedded
  } = useSignupEmbedder();
  const isSU0004Variation = useIsSU0004Variation();
  const {
    shouldShowPrivacyBanner,
    handleClickPrivacyPolicy,
    isOnLandingPage
  } = usePrivacyBanner();
  if (!shouldShowPrivacyBanner) {
    return null;
  }
  const privacyPolicyLink = /*#__PURE__*/_jsx(Text, {
    as: "span",
    color: "text-core-subtle",
    textDecoration: "underline",
    children: /*#__PURE__*/_jsx(Link, {
      external: true,
      hideExternalLinkIcon: true,
      href: getLegalLink('privacy-policy'),
      use: "unstyled",
      onClick: handleClickPrivacyPolicy,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "legal.privacyPolicyLink"
      })
    })
  });
  const privacyPolicyContent = /*#__PURE__*/_jsx(Text, {
    as: "div",
    color: "text-core-subtle",
    typography: "detail-200",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: isSU0004Variation && isOnLandingPage && !isFlow(Flow.Integrations) ? 'legal.gdpr-text-SU0004' : 'legal.gdpr-text-sidepanel',
      options: {
        privacyPolicyLink
      }
    })
  });
  if (isFlow(Flow.Integrations)) {
    const integrationName = getIntegrationName();
    return integrationName ? /*#__PURE__*/_jsx(CustomTermsAndConditions, {
      PrivacyPolicy: privacyPolicyContent,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "legal.integrationsLegalText",
        options: {
          integrationName
        }
      })
    }) : /*#__PURE__*/_jsx(Text, {
      as: "div",
      paddingInline: "400",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(StyledPrivacyBanner, {
        "data-test-id": "legitimate-interest",
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: privacyPolicyContent
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    paddingInline: isTrellisThemeEnabled && isEmbedded ? '400' : undefined,
    textAlign: "center",
    children: /*#__PURE__*/_jsx(StyledPrivacyBanner, {
      "data-test-id": "legitimate-interest",
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: privacyPolicyContent
      })
    })
  });
};
export default PrivacyBanner;